import { Outlet } from "react-router-dom";
import { Link } from "react-router-dom";
import { INDEX } from "../../../constants/routes";
import { AlertProvider } from "../../../app/AlertProvider";
import AlertModal from "../../../components/others/AlertModal";

export default function Add() {
  return (
    <AlertProvider>
      <div className="login">
        <div className="messages_slide">
          {/* <video src="https://www.lavoris.com.ar/frontend/images/video-24-baja.mp4" className="main-video" autoPlay muted loop poster="./assets/img/login/bg-empresa.jpg"></video> */}
        </div>
        <div className="login_right">
          <div className="company_logo">
            <Link to={INDEX}>
              <img src="/images/Logo_Lavorix.png" alt="Lavorix" className="logo" />
            </Link>
            <p>Portal de clientes</p>
          </div>

          <div className="register-form" style={{ width: "100%", maxHeight: "100vh", overflow: "auto" }}>
            <Outlet />
          </div>

          <div className="new_clients">
            <p>
              ¿Ya tienes un usuario?{" "}
              <Link to="/login">
                Inicia sesión aquí
              </Link>
            </p>
          </div>
        </div>
      </div>
      <AlertModal />
    </AlertProvider>
  );
}
